import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import { Dashboard } from './Dashboard';

const App: React.FC = () => {
    const { instance, accounts } = useMsal();
    const [isMsalHandled, setIsMsalHandled] = useState(false);

    useEffect(() => {
        const handleLogin = async () => {
            try {
                if (!isMsalHandled) {
                    setIsMsalHandled(true); // Prevent multiple login attempts
                    await instance.handleRedirectPromise(); // Ensure redirect handling is complete

                    if (accounts.length === 0) {
                        await instance.loginPopup(loginRequest); // Ensure login only happens if no account is logged in
                    }
                }
            } catch (error) {
                console.error("Login failed:", error);
            }
        };

        handleLogin();
    }, [instance, accounts, isMsalHandled]);

    return (
        <div>
            {accounts.length > 0 && <Dashboard />}
        </div>
    );
};

export default App;
